"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryHeader = exports.GalleryContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.GalleryContainer = styled_components_1.default.div `
	background-color: #f1f1f1;
	border-radius: ${props => props.theme.borderRadius.base};
	width: 100%;
	padding: 1rem;
	margin-top: 2rem;
	margin-bottom: 2rem;
	box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
`;
exports.GalleryHeader = styled_components_1.default.div `
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	width: 100%;
	gap: 2rem;
	margin-bottom: 0.5rem;

	div:first-child {
		flex-grow: 9;
	}
	div:nth-child(2) {
		flex-grow: 1;
	}
`;
